import { useEffect } from 'react';
import {
  MinhaAreaEvent,
  MinhaAreaEventName,
  logMinhaAreaEvent,
} from '../../../core/queries/minhaAreaEvents';

/**
 * Módulo do dossiê de incidências, em /disciplinas/interdisciplinar/modulo/...
 *
 * O slug vive aqui, e não no backend, porque o que se quer registrar é o acesso
 * a esta rota — decisão de front. O backend apenas aceita o evento.
 */
const MODULO_DOSSIE = 'dossies-de-incidencias';

/**
 * `type` na URL não bate com o nome da aba: videoaula é o padrão (a rota cai nele
 * quando nada é informado) e `podcast` não tem evento próprio pedido.
 */
const EVENTO_POR_TIPO: Record<string, MinhaAreaEventName> = {
  videoaula: MinhaAreaEvent.DOSSIE_VIDEOAULAS,
  exercicio: MinhaAreaEvent.DOSSIE_EXERCICIOS,
  materiais: MinhaAreaEvent.DOSSIE_MATERIAIS,
};

/**
 * Registra o acesso ao dossiê e à aba aberta.
 *
 * Dois efeitos separados de propósito: entrar no dossiê é um fato, e trocar de
 * aba dentro dele é outro. O backend deduplica por dia, então remontagem de
 * componente e ida e volta entre abas não inflam o log.
 */
export function useLogDossieAccess({
  discipline,
  module,
  type,
}: {
  discipline?: string;
  module?: string;
  type?: string;
}) {
  const noDossie = module === MODULO_DOSSIE;

  useEffect(() => {
    if (!noDossie) {
      return;
    }

    logMinhaAreaEvent(MinhaAreaEvent.DOSSIE_INCIDENCIAS, { discipline, module });
  }, [noDossie, discipline, module]);

  useEffect(() => {
    if (!noDossie) {
      return;
    }

    // Sem `type` na URL a rota exibe videoaula, então é esse o acesso.
    const evento = EVENTO_POR_TIPO[type || 'videoaula'];

    if (!evento) {
      return;
    }

    logMinhaAreaEvent(evento, { discipline, module });
  }, [noDossie, discipline, module, type]);
}

export { MODULO_DOSSIE };
export default useLogDossieAccess;
